import { inviteResponseSchema } from '@si/types';
import { get } from '@si/utils';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from './queryKeys';

interface Params {
  enabled?: boolean;
}

const emptyObject = {} as const;

export function useInvites({ enabled = true }: Params = emptyObject) {
  const { data, error, isPending, isSuccess, refetch } = useQuery({
    queryKey: queryKeys.getInvites,
    queryFn: () =>
      get({
        url: `/api/admin/invites`,
        schema: inviteResponseSchema,
      }),
    enabled,
  });

  return {
    invites: data?.invites ?? [],
    error,
    isPending,
    isSuccess,
    refetch,
  };
}
